const TIMESTAMP_OPTIONS = {
  year: 'numeric',
  month: 'short',
  day: '2-digit',
  hour: 'numeric',
  minute: '2-digit',
  timeZoneName: 'short'
}

export function formatLocalTime(value, { locale, timeZone } = {}) {
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return null

  const options = timeZone ? { ...TIMESTAMP_OPTIONS, timeZone } : TIMESTAMP_OPTIONS
  return new Intl.DateTimeFormat(locale, options).format(date)
}

export function localizeTimes(root = document, formatterOptions = {}) {
  root.querySelectorAll('time[data-local-time]').forEach((element) => {
    const formatted = formatLocalTime(element.dateTime, formatterOptions)
    if (formatted) element.textContent = formatted
  })
}

export function installLocalTime() {
  const localizeDocumentTimes = () => localizeTimes(document)

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', localizeDocumentTimes)
  } else {
    localizeDocumentTimes()
  }
}
